import {
  ITierPattern,
  SmartPairedBayBlock,
  SmartUnpairedBayBlock,
} from "@tedivo/tedivo-bay-grid-pure";

import { IDeckSelectContainerCriteria } from "../useSimpleDeckView";
import { TGetContainersFilterOutput } from "./TGetContainersFilterOutput";
import { getContainersByHighestAll } from "./getContainersByHighestAll";
import { getContainersByHighestBelow } from "./getContainersByHighestBelow";
import { getContainersByHighestBelowOrLowestAbove } from "./getContainersByHighestBelowOrLowestAbove";
import { getContainersByTier } from "./getContainersByTier";

export function obtainFilterFn(
  selectContainerCriteria: IDeckSelectContainerCriteria,
): TObtainFilterFnOutput {
  switch (selectContainerCriteria) {
    case "highestBelowOrLowestAbove":
      return getContainersByHighestBelowOrLowestAbove;
    case "highestAll":
      return getContainersByHighestAll;
    case "highestBelow":
      return getContainersByHighestBelow;
    default:
      return getContainersByTier(selectContainerCriteria as ITierPattern);
  }
}

export type TObtainFilterFnOutput = (
  smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
) => TGetContainersFilterOutput;
